import type { IconTypes } from '@deriv/quill-icons';
import {
    MarketCommodityGoldusdIcon,
    MarketCommodityPalladiumusdIcon,
    MarketCommodityPlatinumusdIcon,
    MarketCommoditySilverusdIcon,
    MarketCryptocurrencyBtcusdIcon,
    MarketCryptocurrencyEthusdIcon,
    MarketDerivedAudBasketIcon,
    MarketDerivedBearIcon,
    MarketDerivedBoom300Icon,
    MarketDerivedBoom500Icon,
    MarketDerivedBoom600Icon,
    MarketDerivedBoom900Icon,
    MarketDerivedBoom1000Icon,
    MarketDerivedBullIcon,
    MarketDerivedCrash300Icon,
    MarketDerivedCrash500Icon,
    MarketDerivedCrash600Icon,
    MarketDerivedCrash900Icon,
    MarketDerivedCrash1000Icon,
    MarketDerivedEurBasketIcon,
    MarketDerivedGbpBasketIcon,
    MarketDerivedGoldBasketIcon,
    MarketDerivedJump10Icon,
    MarketDerivedJump25Icon,
    MarketDerivedJump50Icon,
    MarketDerivedJump75Icon,
    MarketDerivedJump100Icon,
    MarketDerivedRangeBreak100Icon,
    MarketDerivedRangeBreak200Icon,
    MarketDerivedStepIndices100Icon,
    MarketDerivedStepIndices200Icon,
    MarketDerivedStepIndices300Icon,
    MarketDerivedStepIndices400Icon,
    MarketDerivedStepIndices500Icon,
    MarketDerivedUsdBasketIcon,
    MarketDerivedVolatility10Icon,
    MarketDerivedVolatility25Icon,
    MarketDerivedVolatility50Icon,
    MarketDerivedVolatility75Icon,
    MarketDerivedVolatility100Icon,
    MarketDerivedVolatility101sIcon,
    MarketDerivedVolatility151sIcon,
    MarketDerivedVolatility251sIcon,
    MarketDerivedVolatility301sIcon,
    MarketDerivedVolatility501sIcon,
    MarketDerivedVolatility751sIcon,
    MarketDerivedVolatility901sIcon,
    MarketDerivedVolatility1001sIcon,
    MarketDerivedVolatility1501sIcon,
    MarketDerivedVolatility2501sIcon,
    MarketForexAudcadIcon,
    MarketForexAudchfIcon,
    MarketForexAudjpyIcon,
    MarketForexAudnzdIcon,
    MarketForexAudusdIcon,
    MarketForexEuraudIcon,
    MarketForexEurcadIcon,
    MarketForexEurchfIcon,
    MarketForexEurgbpIcon,
    MarketForexEurjpyIcon,
    MarketForexEurnzdIcon,
    MarketForexEurusdIcon,
    MarketForexGbpaudIcon,
    MarketForexGbpcadIcon,
    MarketForexGbpchfIcon,
    MarketForexGbpjpyIcon,
    MarketForexGbpnokIcon,
    MarketForexGbpnzdIcon,
    MarketForexGbpusdIcon,
    MarketForexNzdjpnIcon,
    MarketForexNzdusdIcon,
    MarketForexUsdcadIcon,
    MarketForexUsdchfIcon,
    MarketForexUsdjpyIcon,
    MarketForexUsdmxnIcon,
    MarketForexUsdnokIcon,
    MarketForexUsdplnIcon,
    MarketForexUsdsekIcon,
    MarketIndicesAustralia200Icon,
    MarketIndicesEuro50Icon,
    MarketIndicesFrance40Icon,
    MarketIndicesGerman40Icon,
    MarketIndicesHongKong50Icon,
    MarketIndicesJapan225Icon,
    MarketIndicesNetherlands25Icon,
    MarketIndicesSwiss20Icon,
    MarketIndicesUk100Icon,
    MarketIndicesUs500Icon,
    MarketIndicesUsTech100Icon,
    MarketIndicesWallStreet30Icon,
} from '@deriv/quill-icons';

export const marketIcons: {
    [key: string]: IconTypes;
} = {
    frxaudcad: MarketForexAudcadIcon,
    frxaudchf: MarketForexAudchfIcon,
    frxaudjpy: MarketForexAudjpyIcon,
    frxaudnzd: MarketForexAudnzdIcon,
    frxaudusd: MarketForexAudusdIcon,
    wldaud: MarketDerivedAudBasketIcon,
    rdbear: MarketDerivedBearIcon,
    boom1000: MarketDerivedBoom1000Icon,
    boom600: MarketDerivedBoom600Icon,
    boom900: MarketDerivedBoom900Icon,
    boom300n: MarketDerivedBoom300Icon,
    boom500: MarketDerivedBoom500Icon,
    rdbull: MarketDerivedBullIcon,
    crash1000: MarketDerivedCrash1000Icon,
    crash600: MarketDerivedCrash600Icon,
    crash900: MarketDerivedCrash900Icon,
    crash300n: MarketDerivedCrash300Icon,
    crash500: MarketDerivedCrash500Icon,
    frxxagusd: MarketCommoditySilverusdIcon,
    frxxauusd: MarketCommodityGoldusdIcon,
    frxxpdusd: MarketCommodityPalladiumusdIcon,
    frxxptusd: MarketCommodityPlatinumusdIcon,
    crybtcusd: MarketCryptocurrencyBtcusdIcon,
    cryethusd: MarketCryptocurrencyEthusdIcon,
    wldeur: MarketDerivedEurBasketIcon,
    wldgbp: MarketDerivedGbpBasketIcon,
    wldxau: MarketDerivedGoldBasketIcon,
    jd10: MarketDerivedJump10Icon,
    jd100: MarketDerivedJump100Icon,
    jd25: MarketDerivedJump25Icon,
    jd50: MarketDerivedJump50Icon,
    jd75: MarketDerivedJump75Icon,
    stprng: MarketDerivedStepIndices100Icon,
    stprng2: MarketDerivedStepIndices200Icon,
    stprng3: MarketDerivedStepIndices300Icon,
    stprng4: MarketDerivedStepIndices400Icon,
    stprng5: MarketDerivedStepIndices500Icon,
    rb100: MarketDerivedRangeBreak100Icon,
    rb200: MarketDerivedRangeBreak200Icon,
    wldusd: MarketDerivedUsdBasketIcon,
    '1hz10v': MarketDerivedVolatility101sIcon,
    '1hz100v': MarketDerivedVolatility1001sIcon,
    '1hz150v': MarketDerivedVolatility1501sIcon,
    '1hz250v': MarketDerivedVolatility2501sIcon,
    '1hz25v': MarketDerivedVolatility251sIcon,
    '1hz50v': MarketDerivedVolatility501sIcon,
    '1hz75v': MarketDerivedVolatility751sIcon,
    '1hz15v': MarketDerivedVolatility151sIcon,
    '1hz30v': MarketDerivedVolatility301sIcon,
    '1hz90v': MarketDerivedVolatility901sIcon,
    frxeuraud: MarketForexEuraudIcon,
    frxeurcad: MarketForexEurcadIcon,
    frxeurchf: MarketForexEurchfIcon,
    frxeurgbp: MarketForexEurgbpIcon,
    frxeurjpy: MarketForexEurjpyIcon,
    frxeurnzd: MarketForexEurnzdIcon,
    frxeurusd: MarketForexEurusdIcon,
    frxgbpaud: MarketForexGbpaudIcon,
    frxgbpcad: MarketForexGbpcadIcon,
    frxgbpchf: MarketForexGbpchfIcon,
    frxgbpjpy: MarketForexGbpjpyIcon,
    frxgbpnok: MarketForexGbpnokIcon,
    frxgbpnzd: MarketForexGbpnzdIcon,
    frxgbpusd: MarketForexGbpusdIcon,
    frxnzdjpy: MarketForexNzdjpnIcon,
    frxnzdusd: MarketForexNzdusdIcon,
    frxusdcad: MarketForexUsdcadIcon,
    frxusdchf: MarketForexUsdchfIcon,
    frxusdjpy: MarketForexUsdjpyIcon,
    frxusdmxn: MarketForexUsdmxnIcon,
    frxusdnok: MarketForexUsdnokIcon,
    frxusdpln: MarketForexUsdplnIcon,
    frxusdsek: MarketForexUsdsekIcon,
    otc_as51: MarketIndicesAustralia200Icon,
    otc_sx5e: MarketIndicesEuro50Icon,
    otc_fchi: MarketIndicesFrance40Icon,
    otc_gdaxi: MarketIndicesGerman40Icon,
    otc_hsi: MarketIndicesHongKong50Icon,
    otc_n225: MarketIndicesJapan225Icon,
    otc_aex: MarketIndicesNetherlands25Icon,
    otc_ssmi: MarketIndicesSwiss20Icon,
    otc_ftse: MarketIndicesUk100Icon,
    otc_spc: MarketIndicesUs500Icon,
    otc_ndx: MarketIndicesUsTech100Icon,
    otc_dji: MarketIndicesWallStreet30Icon,
    r_10: MarketDerivedVolatility10Icon,
    r_100: MarketDerivedVolatility100Icon,
    r_25: MarketDerivedVolatility25Icon,
    r_50: MarketDerivedVolatility50Icon,
    r_75: MarketDerivedVolatility75Icon,
} as const;
